import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setImage } from '../../helper';
import * as action from '../../../Pages/Library/DPP/Store/DPP.action';
import noImage from '../../../assets/images/no-image.png';
import AlignmentConfig from '../../../Pages/Library/DPP/Library/ControlConfig/AlignmentConfig';
import ColorConfig from '../../../Pages/Library/DPP/Library/ControlConfig/ColorConfig';
import BoldConfig from '../../../Pages/Library/DPP/Library/ControlConfig/BoldConfig';
import UnderlineConfig from '../../../Pages/Library/DPP/Library/ControlConfig/UnderlineColor';
import FontSizeConfig from '../../../Pages/Library/DPP/Library/ControlConfig/FontSizeConfig';

export function URLLinkSetting({ obj, onChange, updateMetaData, handleURLSwitch, handleImageUpload, handleOtherConfig, handleFontSize }) {
  const { t } = useTranslation('common');
  const [fetchingData, setFetchingData] = useState(false);
  const dispatch = useDispatch();
  const fetchMetadata = async (urlLink) => {
    try {
      const objUrlData = {
        url: urlLink,
      };
      const response = await dispatch(action.getMetaDataforURL(objUrlData, t));
      updateMetaData(response.data);
    } catch (err) {
      console.error('Error fetching metadata:', err);
      updateMetaData({});
    }
  };
  const onChangeURL = async (val, key) => {
    onChange(val, key);
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if ((obj?.url || '') !== '' && obj?.thumbnailURL) {
        setFetchingData(true);
        await fetchMetadata(obj?.url);
        setFetchingData(false);
      }
    }, 2000);

    return () => clearTimeout(delayDebounceFn);
  }, [obj?.url, obj?.thumbnailURL]);

  const getImageSrc = () => {
    if (obj?.metaData?.image?.includes('url_link')) {
      return setImage(obj?.metaData?.image);
    }
    return obj?.metaData?.image || noImage;
  };

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <p className="custom-radio">
          <input
            type="radio"
            id="urlLink"
            value="urlLink"
            onChange={(e) => onChange(e.target.value, 'thumbnailURL')}
            name="url_Link"
            checked={!obj?.thumbnailURL}
          />
          <label className="f-16 text-bold" htmlFor="urlLink">
            {t('DPP.CONTROL.URL_LINK.ONLY_LINK')}
          </label>
        </p>
        <p className="custom-radio ml-4">
          <input
            type="radio"
            id="thumbnailLink"
            value="thumbnailLink"
            onChange={(e) => onChange(e.target.value, 'thumbnailURL')}
            name="url_Link"
            checked={obj?.thumbnailURL}
          />
          <label className="f-16 text-bold" htmlFor="thumbnailLink">
            {' '}
            {t('DPP.CONTROL.URL_LINK.THUBMNAIL_LINK')}
          </label>
        </p>
      </div>
      <div className="form-group url-container">
        <p className="mb-1 f-16 text-bold asterisk-req">
          {t('DPP.CONTROL.URL_LINK.ONLY_LINK')}
          <span className="p-0">*</span>
        </p>
        <input type="url" onChange={(e) => onChangeURL(e.target.value, 'url')} value={obj?.url || ''} className="form-control text-bordered" />
        {fetchingData && <i className="fa fa-spinner fa-spin" />}
      </div>
      {obj?.thumbnailURL ? (
        <>
          <div className="heading-icon-container mb-3">
            <figure>
              <img src={getImageSrc()} alt="" onError={handleImageError} />
            </figure>
            <button type="button" aria-label="Upload" onClick={() => handleImageUpload('url_link', '')} className="btn p-1">
              <i className="icon icon-upload f-14" />
            </button>
          </div>
          <div className="form-group mb-1">
            <div className="custom-control custom-switch">
              <input type="checkbox" checked={obj?.showTitle} onChange={() => handleURLSwitch('showTitle')} className="custom-control-input" id="urlTitle" />
              <label className="custom-control-label" htmlFor="urlTitle">
                {t('DPP.CONTROL.URL_LINK.TITLE')}
              </label>
            </div>
          </div>

          <div className="form-group mb-0">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                checked={obj?.showDescription}
                onChange={() => handleURLSwitch('showDescription')}
                className="custom-control-input"
                id="urlDescription"
              />
              <label className="custom-control-label" htmlFor="urlDescription">
                {t('DPP.CONTROL.URL_LINK.EXCERPT')}
              </label>
            </div>
          </div>
        </>
      ) : (
        <div className="common-input-control mb-0">
          <p className="field-name">
            {t('DPP.CONTROL.URL_LINK.REPLACEMENT_TEXT')}
            <span className="asterisk">*</span>
          </p>
          <input
            type="text"
            className="form-control"
            value={obj?.replacementText || ''}
            placeholder={t('DPP.ENTER_TEXT')}
            onChange={(e) => onChange(e.target.value, 'replacementText')}
            maxLength="40"
          />
        </div>
      )}
      <div className="d-flex">
        <AlignmentConfig obj={obj} handleAlignment={handleOtherConfig} dataName="urlAlignment" />
        <ColorConfig obj={obj} handleColor={handleOtherConfig} dataName="urlColour" />
        <BoldConfig obj={obj} handleBold={handleOtherConfig} dataName="urlBold" />
        <UnderlineConfig obj={obj} handleUnderline={handleOtherConfig} />
      </div>
      <FontSizeConfig obj={obj} handleFontSize={handleFontSize} />
    </>
  );
}

export default URLLinkSetting;
